import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { BehaviorSubject, of } from 'rxjs';
import { templates } from 'src/assets/templates-email';
import { catchError, switchMap } from 'rxjs/operators';
import { StorageService } from './shared/storage.service';
import { GetEmailByCodeResponse } from '../models/email.model';
import * as CryptoJS from 'crypto-js';


@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private storageService: StorageService, private http: HttpClient) { }

    API_URL = environment.ApiUrl;
    ApiKey = environment.ApiKey;
    APP_DOMAIN = environment.domainOnlyAPP;
    ApiDateTime = environment.ApiDateTime;
    userRole = new BehaviorSubject({});
    userData = new BehaviorSubject(null);
    showFooterIllunotes = new BehaviorSubject(true);

    dateServer() {
        return this.http.get(`${this.ApiDateTime}`);
        //return this.http.get('https://api.ezeenotes.com/api/getTimestamp');	
    }
    /*private user$ = new Subject<{}>();
    updateUserData(userData){
        this.user$.next(userData)
    }
    getUser$(): Observable<{}> {
        return this.user$.asObservable();
    }*/

    logOut() {
        this.userRole.next({});
        this.userData.next(null);
        this.storageService.remove('isUserLoggedIn');
        this.storageService.remove('token');
        //this.storageService.remove("credentials"); //pathUserLogin
        //this.storageService.remove('rememberMe');
        //this.storageService.remove("ezze_user_data");
    }

    logOutByToken() {
        this.userRole.next({});
        this.userData.next(null);
        this.storageService.remove('token');
        //this.storageService.remove("ezze_user_data");
    }

    /*getUserData() {//DATA STORAGE VERSION VIEJA
        return this.storageService.get("ezze_user_data");
    }*/

    /*setUserData(user) {
        return this.storageService.set("ezze_user_data", user);
    }*/

    login(credentials) {
        const formData = new FormData();
        const headers = new HttpHeaders();
        const hashedPassword = CryptoJS.SHA256(credentials.password.toString()).toString();
        formData.append("email", credentials.email.toString());
        formData.append("password", hashedPassword);

        return this.http.post(`${this.API_URL}login`, formData, {
            headers: headers,
        });
    }



    getUserFromToken(token) {//traer usuario por token
        let headers = new HttpHeaders();

        //headers = headers.append('Token', token.toString())
        headers = headers.append('Authorization', `Bearer ${token}`);

        return this.http.get(`${this.API_URL}getuserfromtoken`, {
            headers: headers,
        });
    }

    templatesHTML = templates
    register(code, register, dataTemplateEmail) {
        const headers = new HttpHeaders();

        const formPreregistration = new FormData();

        formPreregistration.append("email", register.email.toString());
        formPreregistration.append("code", code ? code.toString() : null);

        return this.http.post(`${this.API_URL}preregistrations/getbyemailcode`, formPreregistration, {
            headers: headers,
        }).pipe(
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            catchError(_ => of({ status: 400 })),
            switchMap((response: GetEmailByCodeResponse) => {
                const formRegister = new FormData();
                const hashedPassword = CryptoJS.SHA256(register.password.toString()).toString();

                if (response.status == 200) {
                    formRegister.append("id_pre_register", response.data.id_pre_register.toString());
                }

                formRegister.append("full_name", register.full_name.toString());
                formRegister.append("email", register.email.toString());
                formRegister.append("password", hashedPassword);

                if (register.cellphone != null) {
                    formRegister.append("cellphone", JSON.stringify(register.cellphone));
                }

                if (dataTemplateEmail.link_access) {
                    formRegister.append("link_access", dataTemplateEmail.link_access);
                }

                if (code != null) {
                    formRegister.append("code", code);
                }

                return this.http.post(`${this.API_URL}users/register`, formRegister, {
                    headers: headers,
                });

            }));
    }

    // Verificar cuenta codigo correo electronico usuario
    verifyEmailAddress(credentials) {
        const formData = new FormData();
        const headers = new HttpHeaders();

        formData.append("email", credentials.email.toString());
        formData.append("verification_code", credentials.verification_code);



        return this.http.post(`${this.API_URL}verifyemail`, formData, {
            headers: headers,
        });
    }

    resendEmailVerification(email, dataTemplateEmail) {
        const formData = new FormData();
        const headers = new HttpHeaders();

        formData.append("email", email.toString());
        formData.append("link_access", dataTemplateEmail.link_access);

        /*formData.append("subject", dataTemplateEmail.subject);
        formData.append("welcome_message", dataTemplateEmail.welcome_message);
        formData.append("message", dataTemplateEmail.message);
        formData.append("title_code", dataTemplateEmail.title_code);
        formData.append("button_message", dataTemplateEmail.button_message);
        formData.append("lang", dataTemplateEmail.lang);
        formData.append("template", this.templatesHTML.verifyEmail);*/

        return this.http.post(`${this.API_URL}users/resendEmailVerification`, formData, {
            headers: headers,
        });
    }

    //new version recover password
    recoverPassword(email) {
        const formEmail = new FormData();
        const headers = new HttpHeaders();
        formEmail.append("email", email.email.toString());
        formEmail.append("link_access", `${this.APP_DOMAIN}/recover-password?key=`);
        return this.http.post(`${this.API_URL}passwordrequest`, formEmail, {
            headers: headers,
        });
    }

    newPasswordRecover(key, password) {
        const formEmail = new FormData();
        let headers = new HttpHeaders();
        const hashedPassword = CryptoJS.SHA256(password.toString()).toString();


        //formEmail.append("key", key.toString());
        formEmail.append("password", hashedPassword);
        headers = headers.append('Authorization', `Bearer ${key}`);


        return this.http.post(`${this.API_URL}finishpasswordrequest`, formEmail, {
            headers: headers,
        });
    }

    changePassword(token, id_user, current_password, password) {
        const formPassword = new FormData();
        let headers = new HttpHeaders();

        const hashedCurrentPassword = CryptoJS.SHA256(current_password.toString()).toString();
        const hashedNewPassword = CryptoJS.SHA256(password.toString()).toString();

        formPassword.append("id_user", id_user.toString());
        formPassword.append("current_password", hashedCurrentPassword);
        formPassword.append("new_password", hashedNewPassword);


        //headers = headers.append('Token', token.toString());
        headers = headers.append('Authorization', `Bearer ${token}`);

        return this.http.post(`${this.API_URL}users/changepassword`, formPassword, {
            headers: headers,
        });
    }

    changeNameAndCellphone(token, full_name, role?, cellphone?) {
        const formPassword = new FormData();
        let headers = new HttpHeaders();

        //formPassword.append("_id", _id.toString());
        formPassword.append("full_name", full_name.toString());
        if (role) {
            formPassword.append("role", role.toString());
        }
        if (cellphone) {
            formPassword.append("cellphone", JSON.stringify(cellphone));
        }

        //headers = headers.append('Token', token.toString());
        headers = headers.append('Authorization', `Bearer ${token}`);

        return this.http.post(`${this.API_URL}users/editself`, formPassword, {
            headers: headers,
        });
    }

    updateUser(token, id_user, formUser) {
        const formPassword = new FormData();
        let headers = new HttpHeaders();

        formPassword.append("id_user", id_user.toString());

        if (formUser.role) {
            formPassword.append("id_user_role", formUser.role.toString());
        }

        if (formUser.full_name) {
            formPassword.append("full_name", formUser.full_name.toString());
        }

        if (formUser.id_institution) {
            formPassword.append("id_institution", formUser.id_institution.toString());
        }

        if (formUser.cellphone) {
            formPassword.append("cellphone", JSON.stringify(formUser.cellphone));
        }


        headers = headers.append('Authorization', `Bearer ${token}`);

        return this.http.post(`${this.API_URL}users/edit`, formPassword, {
            headers: headers,
        });
    }

    updateCellphoneUserWitoutToken(formdata: FormData) {
        const headers = new HttpHeaders();

        return this.http.post(`${this.API_URL}users/updatecellphoneuserwitouttoken`, formdata, {
            headers: headers,
        });
    }

    changePasswordFromAdmin(token, id_user, password) {
        const formPassword = new FormData();
        let headers = new HttpHeaders();
        const hashedPassword = CryptoJS.SHA256(password.toString()).toString();


        formPassword.append("id_user", id_user.toString());
        formPassword.append("password", hashedPassword);


        //headers = headers.append('Token', token.toString());
        headers = headers.append('Authorization', `Bearer ${token}`);
        return this.http.post(`${this.API_URL}users/edit`, formPassword, {
            headers: headers,
        });
    }

    checkToken(token) {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Bearer ${token}`);
        return this.http.get(`${this.API_URL}checktoken`, {
            headers: headers,
        });
    }

    getUsers(token, limit?, page?) {
        let headers = new HttpHeaders();

        //headers = headers.append('Token', token.toString());
        headers = headers.append('Authorization', `Bearer ${token}`);
        return this.http.get(`${this.API_URL}users/list&limit=${limit}&page=${page}`, {
            headers: headers,
        });
    }

    getUserbyId(token, id_user) {
        let headers = new HttpHeaders();

        //headers = headers.append('Token', token.toString());
        headers = headers.append('Authorization', `Bearer ${token}`);
        return this.http.get(`${this.API_URL}users/getbyid/${id_user}`, {
            headers: headers,
        });
    }

    searchUsers(search, token) {
        let headers = new HttpHeaders();
        const formBody = new FormData();

        formBody.append("search_pattern", search);

        //
        //headers = headers.append('Token', token.toString());
        headers = headers.append('Authorization', `Bearer ${token}`);
        return this.http.post(`${this.API_URL}users/list`, formBody, {
            headers: headers,
        });
    }

    deleteUserAdmin(token, user_id) {
        let headers = new HttpHeaders();

        headers = headers.append('Authorization', `Bearer ${token}`);

        return this.http.delete(`${this.API_URL}users/delete/${user_id}`, {
            headers: headers,
        });
    }

    //Contact INSTITUTIONAL QUOTES
    contact(templateEmail) {
        const formContact = new FormData();
        const headers = new HttpHeaders();

        formContact.append("subject", templateEmail.subject.toString());
        formContact.append("email", templateEmail.email.toString());
        formContact.append("name", templateEmail.name.toString());
        if (templateEmail.phone) {
            formContact.append("phone", templateEmail.phone.toString());
        }
        formContact.append("message", templateEmail.message.toString());
        //formContact.append("template", this.templatesHTML.contact);//ya no se usa


        return this.http.post(`${this.API_URL}contact`, formContact, {
            headers: headers,
        });
    }

    newUserFromAdmin(user, token) {
        const userForm = new FormData();
        let headers = new HttpHeaders();
        const hashedPassword = CryptoJS.SHA256(user.password.toString()).toString();


        userForm.append("email", user.email.toString());
        userForm.append("full_name", user.full_name.toString());
        userForm.append("id_user_role", user.role.toString());
        userForm.append("link_access", `${this.APP_DOMAIN}/register-verify-account?email=`);

        if (user.password) {
            userForm.append("password", hashedPassword);
        }
        if (user.id_institution) {
            userForm.append("id_institution", user.id_institution.toString());
        }


        headers = headers.append('Authorization', `Bearer ${token}`);

        return this.http.post(`${this.API_URL}users/create`, userForm, {
            headers: headers,
        });
    }

    sendVerificationCodeViaSMS(id_user) {

        const headers = new HttpHeaders();
        // headers = headers.append('Authorization', `Bearer ${token}`);

        return this.http.get(`${this.API_URL}users/sendsmsverificationcode/${id_user}`, {
            headers: headers,
        });
    }


    verifyViaSMS(form: FormData) {

        const headers = new HttpHeaders();

        return this.http.post(`${this.API_URL}users/verifysms`, form, {
            headers: headers,
        });
    }

    deleteAccount(token) {
        const userForm = new FormData();
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Bearer ${token}`);

        return this.http.post(`${this.API_URL}disableAccount`, userForm, {
            headers: headers,
        });
    }


    sendUserSubscription(subscription: string, token) {
        const subsForm = new FormData();
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Bearer ${token}`);
        subsForm.append("subscription", subscription);

        return this.http.post(`${this.API_URL}users/send-subscription`, subsForm, {
            headers: headers,
        });
    }

}
